import { Link } from 'react-router-dom';
import content from './book-content.json';
import { BOOK_ROUTE } from './book-schema';

export default function ProfileBookSection({ lang = 'ja' }: { lang?: 'ja' | 'en' }) {
  const copy = content[lang].profile;
  return <section className="py-12 md:py-20 bg-[#f5f5f5]" lang={lang} aria-labelledby={`supervised-book-${lang}`}>
    <div className="max-w-6xl mx-auto px-5 sm:px-6 lg:px-8 md:px-8">
      <div className="bg-white rounded-lg p-6 md:p-8 shadow-lg">
        <h2 className="text-xl md:text-5xl font-light text-[#1a1a1a] mb-4 md:mb-8" id={`supervised-book-${lang}`}>{copy.heading}</h2>
        <p className="text-sm md:text-base text-gray-700 leading-relaxed">{copy.paragraph}</p>
        <Link className="inline-block mt-6 text-[#917c50] hover:text-amber-700 transition-colors" to={`${lang === 'en' ? '/en' : ''}${BOOK_ROUTE}`}>{copy.label}</Link>
      </div>
    </div>
  </section>;
}
